import React from 'react'

function Features() {
  return (
    <section className="consulting__area pt-120">
                <div className="container">
                    <div className="row align-items-center flex-row-reverse mt-none-30">
                        <div className="col-lg-6 mt-30">
                            <div className="consulting__img">
                                <img src="assets/img/bg/consult_img.png" alt="" />
                            </div>
                        </div>
                        <div className="col-lg-6 mt-30">
                            <div className="sec__title mb-45">
                                <span className="sub__title"><i className="fas fa-star"></i>We are on a mission</span>
                                <h3 className="title mb-30">Our Mission & Philosophy</h3>
                                <p>Our mission is to work with partners who fully understand the needs and preferences of both clients and candidates, and consistently provide exceptional standards of assessment services based on the values of performance, trust and transparency.</p>
                            </div>
                            <div className="sec__title mb-45">
                                <h4 className="mb-30">Our Philosophy</h4>
                                <p>We are goal oriented. We provide the expected results. We are driven by the ultimate need to add value to our customers. We get the job done.</p>
                            </div>
                            
                            <div className="btns mt-15">
                                <a className="thm_btn" href="#process">Our Process</a>
                                <a className="thm_btn thm_btn-2" href="https://ttnconsulting.zohorecruit.com/jobs/Careers" target="_blank">Careers</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
  )
}

export default Features
